import { UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';
import { CartPageView } from '@lentau/cart/shared/enums';

export const PAGE_VIEW_BASKET: string = CartPageView.Basket;

export const PAGE_VIEW_CHECKOUT: string = CartPageView.Checkout;

export const CART_PAGE_VIEW_ALLOWED_METHODS: readonly string[] = [
  'cartLookup',
  'cartItemAdd',
  'cartItemDelete',
  'cartItemModify',
  'cartItemMultiDelete',
  'cartItemMultiAdd',
];

export const CART_PAGE_VIEW_ROUTES: readonly string[] = [UrlsEnum.OrderingPage, UrlsEnum.BasketPage];
